import * as React from "react"

const Binocular = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72.62 45" {...props}>
    <title>{"parcel-journey-7-binocular-icon-2"}</title>
    <path
      d="M15.63 41.24a12 12 0 1 0-12-12 12 12 0 0 0 12 12Zm15.64-27.83a5.38 5.38 0 0 1 10.05 0V7.88a7.86 7.86 0 0 1 14.54-4.14 5.54 5.54 0 0 1 .3.53l2.56 4.5c1-.07 2.66.22 3.33 1.19l6.73 9.06a17.71 17.71 0 0 1 1.43 2 15.64 15.64 0 1 1-28.38 12.23 6.59 6.59 0 0 1-9.11 2 6.66 6.66 0 0 1-2-2A15.64 15.64 0 1 1 3.81 19.02l6.73-9.09c.66-1 2.36-1.26 3.32-1.19l2.56-4.5.3-.53a7.87 7.87 0 0 1 14.55 4.17Zm5 19.62a3.37 3.37 0 1 0-3.36-3.38 3.37 3.37 0 0 0 3.38 3.37ZM57 41.24a12 12 0 1 0-12-12 12 12 0 0 0 12 12Z"
      fill="#4ead90"
      fillRule="evenodd"
    />
  </svg>
)

export default Binocular
